import React from "react"
import { Link } from "gatsby"
import { ChevronLeft, ChevronRight } from "react-feather"

export default function({ pageContext, type }) {
    if (pageContext.numPages > 1) {
        const listItems = Array.from({ length: pageContext.numPages }).map(
            (_, p) => (
                <Item
                    type={type}
                    currentPage={pageContext.currentPage}
                    page={p + 1}
                    key={`p-b-i-${p}`}
                />
            )
        )

        return (
            <nav className="pagination mt-12">
                <div className="rule mb-6"></div>
                <ul className="flex items-center justify-center">
                    {pageContext.currentPage !== 1 && (
                        <Item
                            type={type}
                            currentPage={pageContext.currentPage}
                            page={pageContext.currentPage - 1}
                            icon={<ChevronLeft size={16} strokeWidth={1.4} />}
                            title="Poprzednia strona"
                        />
                    )}
                    {listItems}
                    {pageContext.currentPage !== pageContext.numPages && (
                        <Item
                            type={type}
                            currentPage={pageContext.currentPage}
                            page={pageContext.currentPage + 1}
                            icon={<ChevronRight size={16} strokeWidth={1.4} />}
                            title="Następna strona"
                        />
                    )}
                </ul>
            </nav>
        )
    }
    return <React.Fragment></React.Fragment>
}

type ItemProps = {
    type: string
    currentPage
    title?: string
    page: number
    icon?: JSX.Element
}
const Item: React.FC<ItemProps> = ({ type, currentPage, title, page, icon }) => {
    const to = `/${type}/${page === 1 ? "" : page}`
    const active = icon ? false : page === currentPage

    const _title =
        title ||
        `${type.charAt(0).toUpperCase()}${type.slice(1)} — strona ${page}`

    return (
        <li className="inline-block align-middle">
            <Link to={to} title={_title} className={active ? "active" : ""}>
                <span>{icon || page}</span>
            </Link>
        </li>
    )
}
